<div class="modal_dialog">
    <div class="modal_header">
        <h2>{{ 'ViewRack' | translate }}</h2>
        <button class="btnn close_icon" [mat-dialog-close]>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="modal_body">
        <ul class="shel_bx">
            <li *ngFor="let shelf of data.element">
                <div class="info_box">
                    <div class="info_box_left">
                        <h3>{{ data.zone.name }}-{{ shelf.level.level }}-{{ shelf.shelve }}</h3>
                        <!-- <span class="item-name" *ngFor="let item of shelf.items" (click)="navigateToProduct(item.variantId)">({{ item.quantity }}) {{ item.productName }}</span> -->
                        <p *ngIf="shelf.items.length && getTotalQuantity(shelf) > 0">
                            {{ getTotalQuantity(shelf) }} {{ 'Total Quantity' | translate }}
                        </p>
                        <p *ngIf="!shelf.items.length || getTotalQuantity(shelf) == 0">{{ 'No Items' | translate }}</p>
                    </div>
                </div>
                <div class="btn_group" *ngIf="shelf.items.length > 0 && getTotalQuantity(shelf) > 0">
                    <button type="button" class="btnn btn_primary" (click)="viewAllProducts(shelf._id)"
                        [mat-dialog-close]>{{ 'ViewAllProducts' | translate }}</button>
                </div>
            </li>
        </ul>
    </div>
</div>